import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeFieldsSelector, makeFormStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const formStyleSelector = makeFormStyleSelector();
  const fieldsSelector = makeFieldsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      fields: fieldsSelector(state, props),
      formStyle: formStyleSelector(state, props),
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
